import { render } from "./FollowCollection.vue?vue&type=template&id=c327fd52"
import script from "./FollowCollection.vue?vue&type=script&lang=js"
export * from "./FollowCollection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__